(() => {
  // Tabbing off the last header item can land focus on an element further down the page
  // (e.g. a video iframe) that the browser does not auto-scroll into view. A cross-origin
  // iframe fires no focusin/keyup once it holds focus, so check on the Tab keydown instead,
  // after the browser's default action (the focus move) has run.
  document.addEventListener('keydown', e => {
    if (e.key !== 'Tab') return;
    setTimeout(() => {
      const el = document.activeElement;
      if (!el || el === document.body) return;
      const r = el.getBoundingClientRect();
      const outOfView = r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= innerWidth;
      if (outOfView) el.scrollIntoView({ block: 'nearest' });
    }, 0);
  });

  const drawer = document.querySelector('.site-drawer');
  const open = document.querySelector('[data-drawer-open]');
  if (!drawer || !open) return;
  const close = drawer.querySelector('[data-drawer-close]');
  const sync = v => open.setAttribute('aria-expanded', v);
  open.addEventListener('click', () => { drawer.showModal(); sync('true'); });
  close?.addEventListener('click', () => drawer.close());
  drawer.addEventListener('close', () => sync('false'));
  drawer.addEventListener('click', e => {
    if (e.target.tagName === 'A' || e.target === drawer) drawer.close();
  });
  const items = [...document.querySelectorAll('.site-nav__toggle')].map(btn => {
    const li = btn.closest('.site-nav__item');
    const sub = li.querySelector('.site-nav__sub');
    const set = v => btn.setAttribute('aria-expanded', v);
    const reset = () => { li.classList.remove('is-open'); sub.style.removeProperty('display'); set('false'); };
    return { btn, li, sub, set, reset };
  });
  items.forEach(({ btn, li, sub, set, reset }) => {
    const enter = () => {
      items.forEach(o => o.li !== li && o.reset());
      if (!sub.style.display) set('true');
    };
    const leave = () => setTimeout(() => {
      if (!li.matches(':hover, :focus-within')) reset();
    }, 0);
    li.addEventListener('mouseenter', enter);
    li.addEventListener('focusin', enter);
    li.addEventListener('mouseleave', leave);
    li.addEventListener('focusout', leave);
    btn.addEventListener('click', () => {
      if (btn.getAttribute('aria-expanded') === 'true') { sub.style.display = 'none'; li.classList.remove('is-open'); set('false'); return; }
      items.forEach(o => o.li !== li && o.reset());
      sub.style.removeProperty('display');
      li.classList.add('is-open');
      set('true');
    });
    li.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || btn.getAttribute('aria-expanded') !== 'true') return;
      sub.style.display = 'none';
      li.classList.remove('is-open');
      set('false');
      btn.focus();
    });
  });
})();
